import { hideScrollBar } from '@repo/ui/components/utilities';
import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import styled, { css } from 'styled-components';

import { FlexColumn, FlexRow } from 'styles/layouts';

export const RoundButton = styled(FlexColumn)`
  gap: 8px;
  width: 72px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

const inactiveStyles = css`
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0.4),
    rgba(255, 255, 255, 0.05)
  );
  mask:
    linear-gradient(to bottom, rgba(255, 255, 255, 0.6) 0 0) content-box,
    linear-gradient(to bottom, ${themeStyle.backgroundAlt} 0 0);
  mask-composite: exclude;
`;

const activeStyles = css`
  background: ${themeStyle.backgroundAlt};
`;

const hoverStyles = css`
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0.4),
    rgba(255, 255, 255, 0.05)
  );
  mask:
    linear-gradient(to bottom, rgba(255, 255, 255, 0.3) 0 0) content-box,
    linear-gradient(to bottom, ${themeStyle.backgroundAlt} 0 0);
  mask-composite: exclude;
`;

export const IconWrapper = styled(FlexColumn)<{ isActive?: boolean }>`
  height: 48px;
  width: 48px;
  justify-content: center;
  align-items: center;
  position: relative;
  z-index: 0;

  &:after {
    aspect-ratio: 1;
    content: '';
    position: absolute;
    z-index: -1;
    inset: 0;
    padding: 1px;
    border-radius: 100%;

    ${(props) => (!props.isActive ? inactiveStyles : activeStyles)}
  }

  ${(props) =>
    !props.isActive &&
    css`
      &:hover:after {
        ${hoverStyles}
      }
    `}
`;

export const Wrapper = styled(FlexRow)`
  gap: 12px;
  margin-bottom: 22px;
  margin-top: 32px;
  overflow-x: scroll;
  ${hideScrollBar};

  & > a:first-child {
    margin-left: 20px;
  }

  ${QUERIES.laptopAndUp} {
    justify-content: center;
    & > a:first-child {
      margin-left: 0px;
    }
  }
`;
